import React from 'react';
import { Field } from '../../components/ui';
import ContactSync from './ContactSync';
import VersionCard from '../../components/VersionCard';

const Row = ({ label, value }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '12px 0', borderBottom: '1px solid var(--line)', fontSize: 14 }}>
    <span className="muted">{label}</span>
    <span style={{ fontWeight: 600, textAlign: 'right' }}>{value || '—'}</span>
  </div>
);

// Mobile (APK) Profile — centred avatar, full-width stacked buttons, the side
// as one big segmented switch.
export default function ProfileMobile({ vm }) {
  const {
    user, organiser, roleLabel, fullName, avatar, editing, setEditing, saving, form, setF, saveProfile, doLogout, goChangePassword,
    event, isMarriage, mySide, sideOptions, chooseSide, savingSide,
  } = vm;
  return (
    <div className="pp-profile-m">
      <div className="card card-pad mobile-record-card">
        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          <div className="avatar avatar-lg" style={{ margin: '0 auto 8px' }}>{avatar}</div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>{fullName || '—'}</div>
          <div className="muted" style={{ fontSize: 13 }}>{roleLabel} · #{user?.UserId}</div>
        </div>

        {editing ? (
          <div>
            <div className="pp-row" style={{ gridTemplateColumns: '1fr 1fr' }}>
              <Field label="Name" autoComplete="given-name" value={form.Name} required onChange={v => setF('Name', v)} />
              <Field label="Surname" autoComplete="family-name" value={form.Surname} onChange={v => setF('Surname', v)} />
            </div>
            <Field label="Mobile Number" type="tel" autoComplete="tel-national" value={form.MobileNumber} required onChange={v => setF('MobileNumber', v)} />
            <Field label="Email" type="email" autoComplete="email" value={form.EmailId} onChange={v => setF('EmailId', v)} />
            <Field label="New Password" type="password" autoComplete="new-password" value={form.Password}
              onChange={v => setF('Password', v)} placeholder="Leave blank to keep current" />
            <Field label="Confirm Password" type="password" autoComplete="new-password" value={form.ConfirmPassword}
              onChange={v => setF('ConfirmPassword', v)} />
            <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
              <button className="btn light" style={{ flex: 1, padding: 12 }} disabled={saving} onClick={() => setEditing(false)}>Cancel</button>
              <button className="btn primary" data-save="primary" style={{ flex: 1, padding: 12 }} disabled={saving} onClick={saveProfile}>{saving ? 'Saving...' : 'Save'}</button>
            </div>
          </div>
        ) : (
          <>
            <Row label="Mobile" value={user?.MobileNumber} />
            <Row label="Email" value={user?.EmailId} />
            <Row label="Organiser" value={organiser?.OrganiserName} />
            {isMarriage && <Row label="My side" value={mySide ? `${mySide} side` : 'Both / Common'} />}
            <button className="btn primary" style={{ width: '100%', padding: 12, marginTop: 14 }} onClick={() => setEditing(true)}>Edit Profile</button>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 8 }}>
              <button className="btn light" style={{ padding: 12 }} onClick={goChangePassword}>Change password</button>
              <button className="btn danger" style={{ padding: 12 }} onClick={doLogout}>Logout</button>
            </div>
          </>
        )}
      </div>

      {/* Which family this user works for — decided here, once. Every guest
          they add afterwards inherits it, so no other screen asks. */}
      {isMarriage && (
        <div className="card card-pad" style={{ marginTop: 10 }}>
          <div className="step-label">My side for {event?.EventName}</div>
          <div className="pp-seg pp-side-seg">
            {sideOptions.map(s => (
              <button key={s} type="button" disabled={!!savingSide}
                className={mySide === s || (!mySide && s === 'Common') ? 'on' : ''}
                onClick={() => chooseSide(s)}>
                {savingSide === s ? '…' : s === 'Common' ? 'Both' : `${s}`}
              </button>
            ))}
          </div>
          <div className="muted" style={{ fontSize: 12, marginTop: 6 }}>
            Guests you add are counted on this side automatically.
          </div>
        </div>
      )}
      <ContactSync user={vm.user} />
      <VersionCard />
    </div>
  );
}
